// @ts-nocheck
import React from 'react';
import { Input, Textarea, SectionCard, AddButton, FormNav } from '../FormField';

export default function CustomSectionTab({ data, onChange, onBack, onNext }) {
  const update = (idx, key, val) => {
    const arr = [...data];
    arr[idx] = { ...arr[idx], [key]: val };
    onChange(arr);
  };

  const add = () =>
    onChange([
      ...data,
      { id: Date.now(), title: '', items: '' },
    ]);

  const remove = (idx) => onChange(data.filter((_, i) => i !== idx));

  return (
    <div>
      {data.map((sec, i) => (
        <SectionCard
          key={sec.id}
          title={sec.title || 'Custom Section'}
          index={i}
          showRemove={data.length > 0}
          onRemove={() => remove(i)}
        >
          <Input
            label="Section Title"
            hint="e.g. Publications, Patents, Languages, Hobbies"
            required
            value={sec.title}
            onChange={(v) => update(i, 'title', v)}
            placeholder="Publications"
          />
          <Textarea
            label="Items"
            hint="one per line"
            required
            value={sec.items}
            onChange={(v) => update(i, 'items', v)}
            placeholder={`"Federated Learning for Healthcare", IEEE ICCCNT 2024 (DOI: 10.1109/ICCCNT...)
"Smart Traffic Management Using Edge AI", Springer CCIS Series, 2023
Best Paper Award, ICMLA 2024 Workshop

Or for Achievements:
Winner, Smart India Hackathon 2024 — 500+ teams
Dean's List, Semesters 5 & 6 (CGPA 9.8/10)
Vice President, ACM Student Chapter — 300+ members`}
            rows={6}
          />
        </SectionCard>
      ))}

      <AddButton onClick={add} label="Add Another Custom Section" />

      <FormNav showBack onBack={onBack} showNext onNext={onNext} nextLabel="Next: Templates →" />
    </div>
  );
}
